import { render, staticRenderFns } from "./iconDeleteQuestion.vue?vue&type=template&id=58e25ec0&scoped=true"
import script from "./iconDeleteQuestion.vue?vue&type=script&lang=js"
export * from "./iconDeleteQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e25ec0",
  null
  
)

export default component.exports